module.exports = __webpack_public_path__ + "img/icon／word备份@2x.cbd4201d.png";